import React, { useEffect, useRef, useState } from "react";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import classes from "./CheckBoxAndRadioWithSearch.module.css";
import PropTypes, { array } from "prop-types";
import { Dropdown } from "react-bootstrap";
import { Checkbox } from "../Checkbox/Checkbox";
import { Radio } from "../Radio/Radio";
import { Button } from "../Button/Button";
import { SearchIconBlack } from "../../constant/imagePath";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";
import { InputWithSearchIcon } from "../InputWithSearchIcon/InputWithSearchIcon";
import useDebounce from "../../CustomHooks/useDebounce";

export const CheckBoxAndRadioWithSearch = ({
  options,
  type,
  onSave,
  isSearch,
  customStyle,
  classNameB,
}) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [renderArray, setRenderArray] = useState(options);
  const debouncedSearch = useDebounce(searchText, 300);

  useEffect(
    () => {
      if (debouncedSearch) {
        searchData();
      }
      if (searchText == "") {
        setRenderArray(options);
      }
    },
    [debouncedSearch, searchText] // Only call effect if debounced search term changes
  );

  const searchData = () => {
    const newArr = options.filter((x) =>
      x.label.toLowerCase().includes(searchText.toLowerCase())
    );
    setRenderArray(newArr);
  };

  return (
    <>
      <Dropdown onToggle={(show) => setOpen(show)} show={true}>
        <Dropdown.Menu
          variant="light"
          show={true}
          className={`${classNameB ? classNameB.main_conti : classes.menu} `}
          style={{ ...customStyle }}
        >
          {/* Search */}
          {isSearch === true && (
            <div className={classes.searchBox}>
              <InputWithSearchIcon
                state={searchText}
                setter={setSearchText}
                placeholder={"Search"}
              />
            </div>
          )}
          {/* Options */}
          <div
            className={`${[
              classes.scrollBar,
              isSearch === false && classes.withoutSearch,
            ].join(" ")}`}
          >
            <ul>
              {renderArray?.map((item, index) => {
                return (
                  <li className={classes.menuItem}>
                    {type === "Checkbox" ? (
                      <Checkbox
                        classNameB={classNameB}
                        label={item?.label}
                        subText={item?.subText}
                        count={item?.count}
                        value={value}
                        setValue={setValue}
                        subTextStyle={{ ...Fonts.p4 }}
                      />
                    ) : (
                      <Radio
                        label={item?.label}
                        count={item?.count}
                        value={value}
                        setValue={setValue}
                      />
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
          <div
            style={{ borderTop: `1px solid ${Colors.neutralShadesOfWhisper}` }}
          />
          <div className={classes.btns}>
            <LinkButtonWithIcon
              text={"Clear"}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
                color: Colors.neutralShadesOfNero,
              }}
            />
            <Button
              label={"Save"}
              primary={true}
              customStyle={{ width: "64px", height: "36px" }}
            />
          </div>
        </Dropdown.Menu>
      </Dropdown>
      <style jsx>{`
        .${classes.scrollBar}::-webkit-scrollbar-thumb {
          background-color: ${Colors.neutralShadesOfGainsboro};
        }
        .${classes.searchBox} input:placeholder {
          color: ${Colors.neutralShadesOfDimGray};
        }
      `}</style>
    </>
  );
};

CheckBoxAndRadioWithSearch.propTypes = {
  options: PropTypes.array,
  onSave: PropTypes.func,
  type: PropTypes.oneOf(["Checkbox", "Radio"]),
  isSearch: PropTypes.bool,
  customStyle: PropTypes.object,
  value: PropTypes.array,
};

CheckBoxAndRadioWithSearch.defaultProps = {
  type: "Checkbox",
  isSearch: false,
  options: [
    { label: "Forehand", subText: "Tennis", count: "(112)" },
    { label: "Backhand", subText: "Tennis", count: "(383)" },
    { label: "Top Spin", subText: "Tennis", count: "(617)" },
    { label: "Serve", subText: "Tennis", count: "(948)" },
    { label: "Serve", subText: "Tennis", count: "(949)" },
    { label: "Serve", subText: "Tennis", count: "(950)" },
  ],
  value: [],
};
